import { pdpRelatedBlogsFactory } from "@/factories/pdp/pdp-header-about-factories";
import { useQuery } from "@tanstack/react-query";

export const fetchRelatedBlogs = (landingPageId: string) => async (): Promise<any> => {
  try {
    const url = `/api/pdp/related-blogs?landingPageId=${landingPageId}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const rawRelatedBlogs = await response.json();
    return pdpRelatedBlogsFactory(rawRelatedBlogs);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error sending GET request:", error); // TODO: log error to error tracking service
    throw error;
  }
};

const useRelatedBlogs = (landingPageId: string) => useQuery({
    queryKey: ["PDP_RELATED-BLOGS", landingPageId],
    queryFn: fetchRelatedBlogs(landingPageId),
    staleTime: Infinity
  });

export default useRelatedBlogs;
